import { constants } from '@airtm/utils';

const { REGEX_FORM_FIELDS } = constants;

export const validGmailAddress = (email) => {
  const username = email.split('@')[0];
  const invalidUsernameRegex = /[+]/;

  return !email.includes('@gmail.') || !invalidUsernameRegex.test(username);
};

export const validateEmail = (email) =>
  new RegExp(REGEX_FORM_FIELDS.REGEX_EMAIL).test(String(email).toLowerCase());

export function validRedirectUrl(target) {
  const url = `${window.location.protocol}//${window.location.host}`;
  return url === target.substr(0, url.length);
}

export function getRedirectPath(target) {
  const url = `${window.location.protocol}//${window.location.host}`;
  return target.substr(url.length);
}
